
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { IAPIMarketingValues } from '@hokify/common';
import { getMarketingLogos } from '@hokify/shared-components/lib/helpers/logos';

const cacheStore = namespace('cache');

@Component({
	name: 'LandingPageHeaderSection'
})
export default class LandingPageHeaderSection extends Vue {
	@cacheStore.State('marketingValues') marketingValues!: IAPIMarketingValues;

	@Prop({ type: Boolean, default: false }) readonly isCandidatesPage?: boolean;

	@Prop({ type: String, default: '' }) readonly fixedHeadline?: string;

	@Prop({ type: String, default: '' }) readonly subHeadline?: string;

	@Prop({ type: String, default: '' }) readonly customButtonText?: string;

	marketingLogos = getMarketingLogos(this.$store.state.topLevelDomain);

	headlines = [
		'passende Mitarbeiter',
		'perfekte Kellner',
		'top KFZ-Mechaniker',
		'motivierte Verkäufer',
		this.$isMobile.phone ? 'ideale Kandidaten' : 'Ihren Wunsch-Kandidaten'
	];

	clickedCTA(pageElement?: 'headline' | 'smartphone', section?: 'intro') {
		// Define a pageElement to use the standard pricing page tracking event. Otherwise we just
		// emit the click event and handle the rest outside.
		// Add section if needed.
		if (pageElement) {
			let elementContent: 'job' | 'kandidaten-finden' | undefined;
			if (pageElement === 'smartphone') {
				if (this.isCandidatesPage) {
					elementContent = 'kandidaten-finden';
				} else {
					elementContent = 'job';
				}
			}
			this.$trackWebsiteEvent('go_to_pricing_page', { pageElement, elementContent });
		}
		this.$emit('clicked-cta', section);
	}
}
